export default __webpack_public_path__ + "static/media/panthertest29.1f85631d.png";